import { Component } from '@angular/core';
import { NavController, Events, App, LoadingController, NavParams } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { DynamicPageCommon } from './dynamic-page.common';

@Component({
	selector: 'dynamic-page-full',
  	templateUrl: 'dynamic-page.full.html'
})

export class DynamicPageFull extends PageBaseFull {
	
	public loader: any;
	public pageId: any;
	public pageData: any;

	constructor(
		public settings: AppSettings,
		public events: Events,
		public nav: NavController,
		public userData: UserData,
		public common: DynamicPageCommon,
        public loadingCtrl: LoadingController,
		private navParams: NavParams,
        public app: App

	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
		this.pageId = navParams.get('id');
	}

	ngAfterViewInit() {
		let self = this;

		self.common.getPageData(self.pageId).subscribe((data) =>{
			// console.log(data);
			self.app.setTitle(data.title);
			self.pageData = data.text;
			self.loader.dismiss();
			setTimeout(()=>{
				console.log("Custom script to Load when page loaded");
				self.appendFooterScripts('assets-full/base/js/page-loaded.js');	
				self.appendFooterScripts('assets-full/base/js/scripts/pages/isotope-grid.js');
			}, 400);
		});
		
	}
	
	ionViewDidEnter() {
		
	}
}


// WEBPACK FOOTER //
// ./src/modules/dynamic-page/pages/dynamic-page/dynamic-page.full.ts